/* @flow */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import type { $Configuration } from 'CoreTypes/Configuration';
import type { $StoreState } from '../../types/StoreState';
import type { $Translation } from 'CoreTypes/Translation';
import FilterType from 'CoreConstants/FilterType';
import WidgetFieldKeys from '../../constants/WidgetFieldsKeys';
import { TemplateMarketPropertyKeys } from 'CoreTemplates/TemplateMarketProperties';
import { getWidgetFieldValueByKey } from 'CoreUtils/WidgetFieldUtils';
import { modifyFilterCriteria } from 'CoreStore/filters';
import { showWidgetField } from 'CoreUtils/WidgetFieldUtils';
import { getConfigurationMarketProperty } from 'CoreUtils/WidgetUtils';
import { mapDealerProductGroupToTranslation } from 'CoreUtils/DealerUtils';
import WBDropdown from '../../../../dealer-locator-core/src/components/WBDropdown/WBDropdown';

type $ComponentProps = {
  checkedFilterProductGroups: Array<string>,
  filterExpanded: boolean,
  onFilterActivityTypeCheck: Function,
  onFilterClose: Function
};

type $MappedProps = {
  appliedFilteringValues: Array<string>,
  configuration: $Configuration,
  market: string,
  translations: Array<$Translation>,
  filterDropdownPlaceholder: string,
  showFilterDropdownPlaceholder: boolean,
  modifyFilterCriteria: Function,
  searchCount: number,
  enabledMarketProductGroups: Array<string>
};

type $Props = $ComponentProps & $MappedProps;

class SearchResultsProductGroupFilterGeneric extends Component<$Props> {

  handleFilteringChange = (value: string) => {
    this.props.modifyFilterCriteria(FilterType.FILTER_PRODUCT_GROUP, [value]);
    this.props.onFilterActivityTypeCheck([value]);
  };

  getFilterItemsList = (enabledProductGroups: Array<string>, translations: Array<$Translation>) => {
    const productGroupOptions = {
      labels: [],
      values: []
    };
    for (const productGroup of enabledProductGroups) {
      const productGroupTranslation = mapDealerProductGroupToTranslation(translations, productGroup);
      if (productGroupTranslation) {
        productGroupOptions.labels.push(productGroupTranslation);
        productGroupOptions.values.push(productGroup);
      }
    }
    return productGroupOptions;
  };


  render() {

    const {
      filterDropdownPlaceholder,
      searchCount,
      showFilterDropdownPlaceholder,
      translations
    } = this.props;

    const enabledProductGroups = this.getFilterItemsList(this.props.enabledMarketProductGroups, translations);

    if (enabledProductGroups.values.length > 0 && enabledProductGroups.labels.length > 0 && searchCount > 0) {
      const labels = [ filterDropdownPlaceholder, ...enabledProductGroups.labels ];
      const values = [ "", ...enabledProductGroups.values ];

      return (
        <div className="dsw-search-results-filter__dropdown">
          <WBDropdown
            placeholder={showFilterDropdownPlaceholder ? filterDropdownPlaceholder : ''}
            labels={labels}
            values={values}
            selectedValue={this.props.appliedFilteringValues.length > 0 ?
              this.props.appliedFilteringValues[0] : ''}
            onChange={this.handleFilteringChange}
            modifierClass={'dsw-search-results-filter__dropdown__wb'}
          />
        </div>
      );
    }
    else return null;
  }
}

const mapStateToProps = (state: $StoreState) => ({
  configuration: state.dsw.configuration,
  market: state.dsw.settings.market,
  translations: state.dsw.translations,
  filterDropdownPlaceholder: getWidgetFieldValueByKey(WidgetFieldKeys.FILTERING_PRODUCT_GROUPS_LABEL, state.dsw),
  showFilterDropdownPlaceholder: showWidgetField(state.dsw.settings, WidgetFieldKeys.FILTERING_PRODUCT_GROUPS_LABEL),
  appliedFilteringValues: state.dsw.filters[ FilterType.FILTER_PRODUCT_GROUP ] || [],
  searchCount: state.dsw.search.searchCount || 0,
  enabledMarketProductGroups: getConfigurationMarketProperty(
    state.dsw.configuration || {},
    state.dsw.settings.market,
    TemplateMarketPropertyKeys.GEN_FILTERS_PRODUCT_GROUPS_ENABLED
  ) || [],
});

const mapDispatchToProps: Object = {
  modifyFilterCriteria
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultsProductGroupFilterGeneric);
